import _head from 'lodash/head';
import _isNil from 'lodash/isNil';
import { HORIZONTAL_POSITIONS, IMAGE_POSITION_BACKGROUND, CONTENT_TYPE_MARKDOWN, FAST_ID_CUSTOM_FORM, VERTICAL_POSITIONS } from './Announcement.constants';
export function shouldRenderHorizontalCard(images, imagePosition) {
  return images.length > 0 && HORIZONTAL_POSITIONS.includes(imagePosition);
}
export function shouldRenderVerticalCard(images, imagePosition) {
  return images.length > 0 && VERTICAL_POSITIONS.includes(imagePosition);
}
export function shouldRenderBackgroundImage(images, imagePosition) {
  return images.length === 1 && imagePosition === IMAGE_POSITION_BACKGROUND;
}
export function shouldRenderSingleImage(images, imagePosition) {
  return images.length === 1 && imagePosition !== IMAGE_POSITION_BACKGROUND;
}
export function shouldRenderImageCarousel(images) {
  return images.length > 1;
}
export function getAnnouncementContent(contentNodes) {
  var contentNode = contentNodes.find(function (contentNodeConfig) {
    return contentNodeConfig.contentType === CONTENT_TYPE_MARKDOWN;
  });
  return contentNode === null || contentNode === void 0 ? void 0 : contentNode.content;
}
export function getCustomFormConfiguration(componentConfigurations) {
  return _head((componentConfigurations || []).filter(function (config) {
    return config.fastId === FAST_ID_CUSTOM_FORM;
  }));
}
export function canSubmitForm(businessType, businessId, locationId) {
  return !_isNil(businessType) && !_isNil(businessId) && !_isNil(locationId);
}
export function formatFieldsForEmailCapture(fields) {
  return fields.map(function (_ref) {
    var label = _ref.label,
      placeholder = _ref.placeholder;
    return {
      key: label,
      label: placeholder
    };
  });
}